module.exports = __webpack_public_path__ + "static/media/hero21 2100X900.deefbf98.png";